// Core React Imports
import React from "react";

// Local Imports
import { AlertDialogBackground, DivColumn, ParagraphText } from "../../../styles/SharedStyles";
import ConstantsImages from "../../../constants/ConstantsImages";
import ConstantsTexts from "../../../constants/ConstantsTexts";
import WidgetIconFive from "../../icons/widget-icon-five/WidgetIconFive";

// CSS/Stylesheets
import "./WidgetAlertDialogFreezeVersion.css";

const WidgetAlertDialogFreezeVersion = ({ modelVersionInt, onCancel, onApprove }) => {
  const mainMessage = ConstantsTexts.CODE_244.replace("{modelNumber}", modelVersionInt);

  return (
    <AlertDialogBackground>
      <DivColumn className="alert-dialog-freeze-version">
        <button type="button" className="alert-dialog-freeze-version-close" onClick={onCancel} aria-label="סגירה">
          <WidgetIconFive iconProp={ConstantsImages.FREEZE_DIALOG_CLOSE_IMAGE} widthIconProp="1rem" heightIconProp="1rem" />
        </button>

        <WidgetIconFive
          iconProp={ConstantsImages.FREEZE_DIALOG_ILLUSTRATION_IMAGE}
          widthIconProp="7.1rem"
          heightIconProp="7.2rem"
        />

        <DivColumn className="alert-dialog-freeze-version-content">
          <ParagraphText className="alert-dialog-freeze-version-title">{ConstantsTexts.CODE_243}</ParagraphText>
          <ParagraphText className="alert-dialog-freeze-version-message">{mainMessage}</ParagraphText>
          <ParagraphText className="alert-dialog-freeze-version-question">{ConstantsTexts.CODE_245}</ParagraphText>
        </DivColumn>

        <button type="button" className="alert-dialog-freeze-version-button" onClick={onApprove}>
          <ParagraphText className="alert-dialog-freeze-version-button-text">{ConstantsTexts.CODE_240}</ParagraphText>
        </button>
      </DivColumn>
    </AlertDialogBackground>
  );
};

export default WidgetAlertDialogFreezeVersion;
